import React from "react";

const PagingInfo = ({ paginator, onPerPageChange, totalPage }) => {
  return (
    <div className="">
      <div className="d-flex justify-content-end">
        <div
          style={{
            lineHeight: 2.5,
            width: 150,
            textAlign: "center",
            fontSize: "0.9rem",
          }}
        >
          <b>Page</b>
          {` ${paginator.page} of ${totalPage}`}
        </div>
      </div>
    </div>
  );
};

export default PagingInfo;
